import {
  CheckCircleOutlined,
  CloseOutlined,
  ErrorOutlineOutlined,
  InfoOutlined,
  ReportProblemOutlined,
} from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { closeSnackbar, type CustomContentProps } from 'notistack'
import { forwardRef } from 'react'

import { TextBody } from '../../data-display/typography/Typography'

import { StyledSnackbarContent, type Variant } from './Snackbar.style'

export const Snackbar = forwardRef<
  HTMLDivElement,
  Omit<CustomContentProps, 'variant'> & { variant: Variant }
>(({ variant, message, id }, ref) => {
  const icons = {
    success: <CheckCircleOutlined />,
    warning: <ReportProblemOutlined />,
    error: <ErrorOutlineOutlined />,
    info: <InfoOutlined />,
  }

  const onClickDismiss = () => {
    closeSnackbar(id)
  }

  return (
    <StyledSnackbarContent
      ref={ref}
      type={variant}
      role="alert"
      message={
        <>
          {icons[variant]}
          <TextBody>{message}</TextBody>
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={onClickDismiss}
            size="small"
          >
            <CloseOutlined />
          </IconButton>
        </>
      }
    />
  )
})
